module.exports = __webpack_public_path__ + "img/1158031787.d44dc7cd.jpg";